import { createSlice } from "@reduxjs/toolkit";
import { updateAppAction } from "../action/updateAppAction";
import { UpdateAppData } from "../types/UpdateAppType";

const initialState: UpdateAppData = {
  data: {},
  loading: false,
  error: null,
};

const opsIndUpdateAppSlice = createSlice({
  name: "opsIndUpdateAppSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateAppAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAppAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateAppAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const updateAppReducer = opsIndUpdateAppSlice.reducer;
